export default "__VITE_ASSET__NAw44R2g__"